module.exports = __webpack_public_path__ + "static/img/Soulja_Boy.0076d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Soulja_Boy.jpg
// module id = fT5F
// module chunks = 1